import axios from '../axios'

const upload = async (file) => {
  try {
    let data = new FormData()
    data.append('file', file, file.name)

    const response = await axios.post('/v1/cdn/upload', data)
    if (response.data.success) {
      return response.data.data
    }
  } catch (err) {
    console.log(err)
  }
}

export default upload
